import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonashikcab() {



const cardData = {
  keyword: "Mumbai to Nashik Cab",
  heading: "Lotus Cab: Mumbai to Nashik Cab",

  headingDescription:
    "Lotus Cab provides safe, comfortable, and affordable Mumbai to Nashik cab services for pilgrims, wine tourism travelers, families, and corporate guests. The highway journey between Mumbai and Nashik is smooth yet requires experienced drivers and well-maintained vehicles for complete comfort. Whether you need a one-way drop, round-trip package, weekend getaway plan, or same-day return service, we offer flexible travel solutions with transparent per-kilometer pricing. Our fleet includes AC sedans, spacious SUVs, luxury cars, and mini buses for group tours. Professional, background-verified chauffeurs ensure punctual pickup and safe highway driving. With 24/7 booking support and reliable service across Mumbai, Lotus Cab guarantees a stress-free and enjoyable Nashik road trip.",

  top: "Top Places to Visit in Nashik with Lotus Cab",

  topPlaces: [
    {
      title: "Trimbakeshwar Temple",
      description:
        "Trimbakeshwar Temple is one of the 12 Jyotirlingas and a major pilgrimage destination near Nashik. Devotees visit throughout the year for spiritual blessings. The temple is located amidst scenic hills offering peaceful surroundings. Comfortable AC cab travel ensures relaxed long-distance journey. SUV vehicles are recommended for family visits. Lotus Cab provides flexible darshan waiting packages."
    },
    {
      title: "Sula Vineyards",
      description:
        "Sula Vineyards is one of India’s most famous wine destinations. Visitors enjoy vineyard tours, wine tasting sessions, and scenic landscapes. It is perfect for weekend relaxation and corporate outings. The smooth highway drive enhances travel comfort. Sedan and SUV options available. Lotus Cab ensures convenient pickup and return."
    },
    {
      title: "Panchavati",
      description:
        "Panchavati is a sacred area associated with the Ramayana. Pilgrims visit temples and ghats along the Godavari River. The spiritual environment attracts families and senior citizens. AC cab service ensures comfortable travel. Flexible sightseeing schedule provided. Lotus Cab offers reliable city transfers."
    },
    {
      title: "Anjneri Hills",
      description:
        "Anjneri Hills is believed to be the birthplace of Lord Hanuman. It attracts trekking enthusiasts and spiritual visitors. The scenic location offers panoramic views. SUV vehicles recommended for safe hill travel. Lotus Cab ensures smooth and secure transportation."
    },
    {
      title: "Muktidham Temple",
      description:
        "Muktidham Temple is known for its marble architecture and replicas of important Hindu shrines. It is a peaceful religious site. Families prefer visiting during Nashik trips. Comfortable AC cab travel enhances the experience. Lotus Cab provides convenient drop services."
    },
    {
      title: "Pandavleni Caves",
      description:
        "Pandavleni Caves are ancient rock-cut caves offering historical and scenic charm. The location is popular among history lovers and photographers. The elevated site provides beautiful city views. Comfortable cab service ensures easy access. Lotus Cab offers flexible travel packages."
    }
  ],

  services: [
    {
      name: "Mumbai to Nashik Cab",
      description:
        "Lotus Cab offers reliable Mumbai to Nashik cab services with experienced highway drivers. AC sedans and SUVs ensure smooth and comfortable long-distance travel. Transparent per-kilometer pricing shared before booking confirmation. Ideal for pilgrimage, business, and weekend trips. Flexible one-way and round-trip options available. 24/7 booking assistance provided."
    },
    {
      name: "One Way Cab Mumbai to Nashik",
      description:
        "Affordable one-way drop service where you pay only for single-side travel distance. Suitable for pilgrims and corporate guests. Clean AC vehicles maintained regularly. Professional chauffeurs ensure safe driving. Transparent billing policy followed."
    },
    {
      name: "Round Trip Cab Mumbai to Nashik",
      description:
        "Flexible round-trip packages available for same-day or multi-day travel. Comfortable AC vehicles provided. Return timing customizable as per your schedule. Ideal for family trips and vineyard tours. Safe highway travel ensured."
    },
    {
      name: "SUV Cab Mumbai to Nashik",
      description:
        "Spacious SUV taxis ideal for family and group travel. Extra luggage capacity available. Smooth highway performance ensures safe travel. Comfortable seating for long-distance journeys. Flexible booking options provided."
    },
    {
      name: "Luxury Cab Mumbai to Nashik",
      description:
        "Premium luxury vehicles available for executive and VIP travel. Professional chauffeur-driven service included. Superior interior comfort maintained. Ideal for corporate guests and special occasions."
    },
    {
      name: "Budget Cab Mumbai to Nashik",
      description:
        "Economical sedan options available for affordable travel. Fuel-efficient vehicles help maintain budget-friendly pricing. AC comfort included. Transparent per-km fare shared before booking."
    }
  ],

  tableData: [
    ["Mumbai to Nashik Cab", "One Way Cab Mumbai to Nashik"],
    ["Round Trip Cab Mumbai to Nashik", "AC Cab Mumbai to Nashik"],
    ["Sedan Cab Mumbai to Nashik", "SUV Cab Mumbai to Nashik"],
    ["Luxury Cab Mumbai to Nashik", "Online Booking Cab Mumbai to Nashik"],
    ["Family Trip Cab Mumbai to Nashik", "Corporate Cab Mumbai to Nashik"],
    ["Weekend Trip Cab Mumbai to Nashik", "Mini Bus Mumbai to Nashik"],
    ["Chauffeur Driven Cab Mumbai to Nashik", "Picnic Trip Cab Mumbai to Nashik"],
    ["Budget Cab Mumbai to Nashik", "Same Day Return Cab Mumbai to Nashik"],
    ["Outstation Taxi Service Mumbai to Nashik", "Per Km Rate Cab Mumbai to Nashik"],
    ["Best Cab Service Mumbai to Nashik", "Group Tour Cab Mumbai to Nashik"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription:
        "Drivers trained for long-distance highway routes ensuring safe and smooth travel experience."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Upfront pricing with clear breakdown shared before booking confirmation."
    },
    {
      WhyChooseheading: "Wide Fleet Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury cars, and mini bus options available."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock booking support across Mumbai."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription:
        "Packages suitable for pilgrimage and corporate travel."
    },
    {
      WhyChooseheading: "Clean & Sanitized Vehicles",
      WhyChoosedescription:
        "Vehicles regularly cleaned and maintained."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and same-day return packages available."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated assistance provided during entire journey."
    }
  ]
};

const faqData = [
  {
    question: "How long does Mumbai to Nashik travel take?",
    answer:
      "The journey usually takes around 3 to 4 hours depending on traffic conditions. Our drivers ensure safe highway travel."
  },
  {
    question: "Is one-way drop available?",
    answer:
      "Yes, affordable one-way drop service available with transparent pricing."
  },
  {
    question: "Is SUV recommended for family travel?",
    answer:
      "SUV is ideal for family and group travel due to extra comfort and luggage space."
  },
  {
    question: "Is AC included?",
    answer:
      "Yes, all vehicles are fully air-conditioned for comfortable travel."
  },
  {
    question: "Is same-day return possible?",
    answer:
      "Yes, same-day return packages available for pilgrimage or business trips."
  },
  {
    question: "Are luxury vehicles available?",
    answer:
      "Yes, premium vehicles available for executive and VIP travel."
  },
  {
    question: "Is online booking available?",
    answer:
      "Yes, instant online booking confirmation provided."
  },
  {
    question: "Is per km pricing transparent?",
    answer:
      "Yes, complete fare breakdown shared before booking confirmation."
  },
  {
    question: "Do you offer corporate billing?",
    answer:
      "Yes, invoice billing support available for corporate clients."
  },
  {
    question: "Is group travel available?",
    answer:
      "Yes, mini bus and SUV options available for group tours."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Desai",
    feedback:
      "Booked cab for Trimbakeshwar darshan. Smooth journey and professional driver. Very comfortable ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Family trip to Nashik was comfortable and affordable. SUV was spacious and clean.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable service for business travel. Transparent pricing and punctual pickup.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Amit Shah",
    feedback:
      "Excellent cab service with no hidden charges. Highly recommend for Nashik travel.",
    rating: 5
  }
];
































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nashik Cab",
  "image": "https://lotuscab.com/assets/images/mumbai-to-nashik-cab.jpg", 
  "description": "Lotus Cab offers Mumbai to Nashik cab services with AC, sedan, SUV, luxury cabs, and Mini Bus options. Perfect for one-way trips, round trips, family travel, corporate transfers, weekend trips, group tours, picnic trips, and same-day returns. Online booking available with chauffeur-driven cabs and competitive per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "970"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-to-nashik-cab"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Mumbai to Nashik Cab | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Nashik cab with Lotus Cab. AC, sedan, SUV, luxury cabs & Mini Bus for one-way, round trips, family, corporate, weekend, group & picnic travel. Online booking available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Nashik Cab, One Way Cab Mumbai to Nashik, Round Trip Cab Mumbai to Nashik, AC Cab Mumbai to Nashik, Sedan Cab Mumbai to Nashik, SUV Cab Mumbai to Nashik, Luxury Cab Mumbai to Nashik, Online Booking Cab Mumbai to Nashik, Family Trip Cab Mumbai to Nashik, Corporate Cab Mumbai to Nashik, Weekend Trip Cab Mumbai to Nashik, Mini Bus Mumbai to Nashik, Chauffeur Driven Cab Mumbai to Nashik, Picnic Trip Cab Mumbai to Nashik, Budget Cab Mumbai to Nashik, Same Day Return Cab Mumbai to Nashik, Outstation Taxi Service Mumbai to Nashik, Per Km Rate Cab Mumbai to Nashik, Best Cab Service Mumbai to Nashik, Group Tour Cab Mumbai to Nashik" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitonashikcab;